import { Col, Collapse, ConfigProvider, Row, Tabs } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table } from "antd";
import PdfPreview from "../../../biblio/Modal/PdfPreview";
import {
  FileOutlined,
  PlusCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import SecondaryButton from "../../../biblio/Buttons/SecondaryButton";
import Inputs from "../../../biblio/Inputs/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  toEditHousingInfos,
  toEditBeneficiaryHousing,
  getAllAcademicsYears,
  getAllDisabilityTypes,
  getAllDiseaseType,
  getAllHealthStates,
  getAllNationality,
  getAllMaritalStatus,
  getAllIdentificationTypes,
  toEditBeneficiaryPersons,
  getBeneficiaryDetails,
  getAllAcademicsPerformance,
  getAllIncomeSources,
  toEditIncomeSource,
  getAllHousingStates,
  getAllHousingTypes,
  getAllHousingOwnerships,
  toEditGuardianInfos,
} from "../../../apis/actions/recipient.actions";
import { getAcademicLevels } from "../../../apis/actions/monitoring.actions";
import Selects from "../../../biblio/Selects/Selects";
import ar_EG from "antd/lib/locale/ar_EG";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import ModalComponent from "../../../biblio/Modal/ModalComponent";
import {
  convertFileToBase64,
  showNotitfication,
} from "../../../components/utils/utils";
import HijriFeature from "../../../biblio/HijriFeature";
import { setEditMode } from "../../../apis/slices/recipientSlice";
import TagComponent from "../../../biblio/TagComponent";
import UploadInput from "../../../biblio/Inputs/UploadInput";
import { toGetAllBanks } from "../../../apis/actions/sponsor.actions";
import EditLiablityTable from "./editLiability";

interface CollapseProps {
  className?: string;
  CollapseArray: any;
  tabsData: any[];
}
const CollapseContent = ({
  CollapseArray,
  tabsData,
  ...props
}: CollapseProps) => {
  const { t } = useTranslation();
  const data = Array.isArray(CollapseArray.person_ids)
    ? CollapseArray.person_ids
    : [];
  const [editedPersons, setEditedPersons] = useState<{ [key: number]: any }>(
    {}
  );
  const [materialStateData, setMaterialStateData] = useState<any[]>([]);
  const [liabilityData, setLiabilityData] = useState<any[]>([]);
  const [updatedMaterialStateData, setUpdatedMaterialStateData] = useState<
    any[]
  >([]);
  const [isModalIncomeVisible, setIsModalIncomeVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [housingStatesData, setHousingStatesData] = useState<any[]>([]);
  const [updatedhousingStatesData, setUpdatedHousingStatesData] = useState<
    any[]
  >([]);
  const [isModalVisibleHousing, setIsModalVisibleHousing] = useState(false);
  const [isModalVisibleHousingInfos, setIsModalVisibleHousingInfos] =
    useState(false);
  const [isModalVisibleGuardianInfos, setIsModalVisibleGuardianInfos] =
    useState(false);
  const handleHousingInputChange = (field: string, value: any | any[]) => {
    setHousingInfos({ ...housingInfos, [field]: value });
  };
  const handleGuardianInputChange = (field: string, value: any | any[]) => {
    setGuardianInfos({ ...guardianInfos, [field]: value });
  };
  const newRowTemplate = {
    key: materialStateData.length,
    source_income_id: null,
    amount: 0,
    beneficiaries_number: 0,
    amount_by_person: 0,
  };
  const newRowTemplateHousing = {
    key: materialStateData.length,
    id: null,
    amount: 0,
    housing_type_id: null,
    housing_state_id: null,
  };
  const addNewRow = () => {
    const uniqueKey = Date.now();
    setMaterialStateData((prev) => [
      ...prev,
      { ...newRowTemplate, key: uniqueKey },
    ]);
  };
  const addNewRowHousing = () => {
    const uniqueKey = Date.now();
    setHousingStatesData((prev) => [
      ...prev,
      { ...newRowTemplateHousing, key: uniqueKey },
    ]);
  };
  const cancelModificationGuardianInfos = () => {
    setIsModalVisibleGuardianInfos(false);
  };
  const cancelIncomeModification = () => {
    setIsModalIncomeVisible(false);
  };
  const cancelModificationHousing = () => {
    setIsModalVisibleHousing(false);
  };
  const cancelModificationHousingInfos = () => {
    setIsModalVisibleHousingInfos(false);
  };
  const cancelModification = () => {
    setIsModalVisible(false);
  };
  const handleInputChange = (personId: number, field: string, value: any) => {
    setEditedPersons((prev) => ({
      ...prev,
      [personId]: {
        ...prev[personId],
        person_id: personId,
        [field]: value,
      },
    }));
  };
  useEffect(() => {
    if (Array.isArray(CollapseArray?.material_state_ids)) {
      setMaterialStateData([...CollapseArray.material_state_ids]);
    }
    if (Array.isArray(CollapseArray?.housing_type_ids)) {
      setHousingStatesData([...CollapseArray.housing_type_ids]);
    }
    if (Array.isArray(CollapseArray?.liability_ids)) {
      setLiabilityData([...CollapseArray.liability_ids]);
    }
  }, [CollapseArray]);

  const handleSourceIncomeChange = (
    index: number,
    field: string,
    value: any
  ) => {
    setMaterialStateData((prev) => {
      const updatedData = [...prev];
      if (!updatedData[index]) return prev;

      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      setUpdatedMaterialStateData((prevChanges) => {
        const changes = [...prevChanges];
        const existingChangeIndex = changes.findIndex((item) =>
          item.key
            ? item.key === updatedData[index].key
            : item.id === updatedData[index].id
        );

        if (existingChangeIndex !== -1) {
          changes[existingChangeIndex] = {
            ...changes[existingChangeIndex],
            [field]: value,
          };
        } else {
          changes.push({
            key: updatedData[index].key,
            id: updatedData[index].id,
            [field]: value,
          });
        }

        return changes;
      });

      return updatedData;
    });
  };
  const handleHousingChange = (index: number, field: string, value: any) => {
    setHousingStatesData((prev) => {
      const updatedData = [...prev];
      if (!updatedData[index]) return prev;

      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      setUpdatedHousingStatesData((prevChanges) => {
        const changes = [...prevChanges];
        const existingChangeIndex = changes.findIndex((item) =>
          item.key
            ? item.key === updatedData[index].key
            : item.id === updatedData[index].id
        );

        if (existingChangeIndex !== -1) {
          changes[existingChangeIndex] = {
            ...changes[existingChangeIndex],
            [field]: value,
          };
        } else {
          changes.push({
            key: updatedData[index].key,
            id: updatedData[index].id,
            [field]: value,
          });
        }

        return changes;
      });

      return updatedData;
    });
  };
  const {
    diseaseType,
    identificationTypes,
    maritalStatus,
    academicYears,
    editMode,
    academicsPerformance,
    incomeSources,
    housingStates,
    housingTypes,
    housingOwnerships,
    beneficiaryDetails,
    nationality,
  } = useSelector((state: RootState) => state.recipient);
  const { healthStates } = useSelector((state: RootState) => state.recipient);
  const { data: academicLevels } = useSelector(
    (state: RootState) => state?.monitoring.academicLevels
  );
  const banks = useSelector((state: RootState) => state?.sponsor.banks);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    if (editMode) {
      dispatch(getAllAcademicsPerformance());
      dispatch(getAllDiseaseType());
      dispatch(getAcademicLevels());
      dispatch(getAllNationality());
      dispatch(getAllHealthStates());
      dispatch(getAllDisabilityTypes());
      dispatch(getAllMaritalStatus());
      dispatch(getAllIdentificationTypes());
      dispatch(getAllMaritalStatus());
      dispatch(getAllAcademicsYears());
      dispatch(getAllIncomeSources());
      dispatch(getAllHousingStates());
      dispatch(getAllHousingTypes());
      dispatch(getAllHousingOwnerships());
      dispatch(getBeneficiaryDetails());
      dispatch(toGetAllBanks());
    }
    dispatch(getBeneficiaryDetails());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode]);
  const [isOwned, setIsOwned] = useState(false);
  const typeOrder = ["father", "mother", "son", "daughter"];
  const [pdfUrl, setPdfUrl] = useState<string>("");
  // Sort data based on the typeOrder
  const sortedData = [...data].sort(
    (a, b) =>
      typeOrder.indexOf(a.beneficiary_type) -
      typeOrder.indexOf(b.beneficiary_type)
  );
  const columnsIncomeSource = [
    {
      title: "مصدر الدخل",
      dataIndex: "source_income_id",
      key: "source_income_id",
      width: "25%",
      render: (text: string, record: any, index: number) =>
        editMode ? (
          <Selects
            value={record.source_income_id}
            onChange={(SelectedValue: any) =>
              handleSourceIncomeChange(
                index,
                "source_income_id",
                SelectedValue.key
              )
            }
            options={incomeSources.data}
          />
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: "المبلغ",
      dataIndex: "amount",
      key: "amount",
      width: "25%",
      render: (text: string, record: any, index: number) =>
        editMode ? (
          <Inputs
            type="tel"
            value={record.amount}
            onChange={(e) =>
              handleSourceIncomeChange(
                index,
                "amount",
                parseFloat(e.target.value)
              )
            }
          />
        ) : (
          <span className="takaful--service-request-span">{text}</span>
        ),
    },
    {
      title: "عدد المستفيدين",
      dataIndex: "beneficiaries_number",
      key: "beneficiaries_number",
      width: "25%",
      render: (text: string, record: any, index: number) =>
        editMode ? (
          <Inputs
            type="tel"
            value={record.beneficiaries_number}
            onChange={(e) =>
              handleSourceIncomeChange(
                index,
                "beneficiaries_number",
                parseInt(e.target.value)
              )
            }
          />
        ) : (
          <span className="takaful--service-request-span">{text}</span>
        ),
    },
    {
      title: "مبلغ الفرد الواحد",
      dataIndex: "amount_by_person",
      key: "amount_by_person",
      width: "25%",
      render: (text: string | number, record: any) => {
        return (
          <span className="takaful--service-request-span">
            {record.amount > 0 && record.beneficiaries_number > 0
              ? record.amount / record.beneficiaries_number
              : 0}
          </span>
        );
      },
    },

    {
      // eslint-disable-next-line eqeqeq
      title: editMode == true && (
        <PrimaryButton
          icon={<PlusCircleOutlined />}
          title=""
          onClick={addNewRow}
        />
      ),
    },
  ];
  const columnsProperty = [
    {
      title: "النوع",
      dataIndex: "housing_type_id",
      key: "housing_type_id",
      width: "33%",
      render: (text: string, record: any, index: number) =>
        editMode ? (
          <Selects
            value={record.housing_type_id}
            onChange={(SelectedValue: any) =>
              handleHousingChange(index, "housing_type_id", SelectedValue.key)
            }
            options={housingTypes.data}
          />
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: "الحالة",
      dataIndex: "housing_state_id",
      key: "housing_state_id",
      width: "33%",
      render: (text: string, record: any, index: number) =>
        editMode ? (
          <Selects
            value={record.housing_state_id}
            onChange={(SelectedValue: any) =>
              handleHousingChange(index, "housing_state_id", SelectedValue.key)
            }
            options={housingStates.data}
          />
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: "المبلغ",
      dataIndex: "amount",
      key: "amount",
      width: "33%",
      render: (text: string, record: any, index: number) =>
        editMode ? (
          <Inputs
            type="tel"
            value={record.amount}
            onChange={(e) =>
              handleHousingChange(index, "amount", parseInt(e.target.value))
            }
          />
        ) : (
          <span className="takaful--service-request-span">{text}</span>
        ),
    },
    {
      // eslint-disable-next-line eqeqeq
      title: editMode == true && (
        <PrimaryButton
          icon={<PlusCircleOutlined />}
          title=""
          onClick={addNewRowHousing}
        />
      ),
    },
  ];

  const confirmModification = () => {
    try {
      const personArray = Object.values(editedPersons);
      const apiPayload = {
        person_ids: personArray,
      };
      dispatch(toEditBeneficiaryPersons(apiPayload)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisible(false);
          dispatch(getBeneficiaryDetails());
          dispatch(setEditMode(false));
        } else {
          showNotitfication(response?.message, "error");
          setIsModalVisible(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const confirmIncomeModification = () => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const filteredMaterialStateData = updatedMaterialStateData
        .map((item) => {
          if (item.id === undefined) {
            delete item.id;
          }
          delete item.key;
          return item;
        })
        .filter(
          (item) => Object.keys(item).length > 0 && item.source_income_id
        );

      const apiPayload = {
        material_state_ids: [...updatedMaterialStateData],
      };

      dispatch(toEditIncomeSource(apiPayload)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalIncomeVisible(false);
          dispatch(getBeneficiaryDetails());
          dispatch(setEditMode(false));
          setUpdatedMaterialStateData([]);
        } else {
          showNotitfication(response?.message, "error");
          setIsModalIncomeVisible(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const confirmIncomeModificationHousing = () => {
    try {
      const filteredHousingData = updatedhousingStatesData.map((item) => {
        if (item.id === undefined) {
          delete item.id;
        }
        delete item.key;
        return item;
      });

      const apiPayload = {
        housing_type_ids: [...filteredHousingData],
      };

      dispatch(toEditBeneficiaryHousing(apiPayload)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisibleHousing(false);
          dispatch(getBeneficiaryDetails());
          dispatch(setEditMode(false));
          setUpdatedHousingStatesData([]);
        } else {
          showNotitfication(response?.message, "error");
          setIsModalVisibleHousing(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleFileChange = async (fileList: any[]) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        setHousingInfos({
          ...housingInfos,
          electronic_contract_attachment_ids: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };
  const confirmModificationGuardianInfos = () => {
    try {
      dispatch(toEditGuardianInfos(guardianInfos)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisibleGuardianInfos(false);
          dispatch(getBeneficiaryDetails());
          dispatch(setEditMode(false));
        } else {
          showNotitfication(response?.message, "error");
          setIsModalVisibleGuardianInfos(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const confirmModificationHousingInfos = () => {
    try {
      dispatch(toEditHousingInfos(housingInfos)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisibleHousingInfos(false);
          dispatch(getBeneficiaryDetails());
          dispatch(setEditMode(false));
        } else {
          showNotitfication(response?.message, "error");
          setIsModalVisibleHousingInfos(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const getSelectValueByname = (name: string, field: string) => {
    if (field === "academic_level") {
      const match = academicLevels?.find((item: any) => item.name === name);
      return match?.id || "";
    } else if (field === "marital_status") {
      const match = maritalStatus?.data?.find(
        (item: any) => item.name === name
      );
      return match?.id || "";
    } else if (field === "health_state") {
      const match = healthStates?.data?.find((item: any) => item.name === name);
      return match?.id || "";
    } else if (field === "identification_type") {
      const match = identificationTypes?.data?.find(
        (item: any) => item.name === name
      );
      return match?.id || "";
    } else if (field === "academic_year") {
      const match = academicYears?.find((item: any) => item.name === name);
      return match?.id || "";
    } else if (field === "academic_performance") {
      const match = academicsPerformance?.find(
        (item: any) => item.name === name
      );
      return match?.id || "";
    } else if (field === "housing_type") {
      const match = housingTypes?.data?.find((item: any) => item.name === name);
      return match?.id || "";
    } else if (field === "housing_ownership") {
      const match = housingOwnerships.data?.find(
        (item: any) => item.name === name
      );
      return match?.id || "";
    } else if (field === "housing_state") {
      const match = housingStates.data?.find((item: any) => item.name === name);
      return match?.id || "";
    } else if (field === "nationality") {
      const match = nationality.data?.find((item: any) => item.name === name);
      return match?.id || "";
    } else if (field === "bank") {
      const match = banks?.find((item: any) => item.name === name);
      return match?.id || name;
    }
  };
  const [housingInfos, setHousingInfos] = useState({
    housing_type_id: "",
    housing_ownership_id: "",
    housing_state_id: "",
    rooms_number: 0,
    rent_amount: 0,
    housing_description: "",
    electronic_contract_attachment_ids: CollapseArray.electronic || [],
  });
  const [guardianInfos, setGuardianInfos] = useState({
    guardian_name: "",
    guardian_identification_type_id: -1,
    guardian_identification: "",
    guardian_email: "",
    guardian_nationality_id: -1,
    guardian_actual_profession: "",
    guardian_address: "",
    guardian_phone: 0,
    guardian_marital_status_id: -1,
    guardian_account_number: 0,
    guardian_bank_id: 0,
    guardian_account_owner: "",
  });
  useEffect(() => {
    if (beneficiaryDetails) {
      setHousingInfos({
        housing_type_id: getSelectValueByname(
          beneficiaryDetails?.housing_type_id,
          "housing_type"
        ),
        housing_ownership_id: getSelectValueByname(
          beneficiaryDetails?.housing_ownership_id,
          "housing_ownership"
        ),
        housing_state_id: getSelectValueByname(
          beneficiaryDetails?.housing_state_id,
          "housing_state"
        ),
        rooms_number: beneficiaryDetails?.rooms_number,
        rent_amount: beneficiaryDetails?.rent_amount,
        housing_description: beneficiaryDetails?.housing_description,
        electronic_contract_attachment_ids:
          beneficiaryDetails?.electronic || [],
      });
      // eslint-disable-next-line eqeqeq
      setIsOwned(beneficiaryDetails?.housing_ownership_id == "ملك");
      setGuardianInfos({
        guardian_name: beneficiaryDetails?.guardian_name,
        guardian_identification_type_id: getSelectValueByname(
          beneficiaryDetails?.guardian_identification_type_id,
          "identification_type"
        ),
        guardian_identification: beneficiaryDetails?.guardian_identification,
        guardian_email: beneficiaryDetails?.guardian_email || "",
        guardian_nationality_id: getSelectValueByname(
          beneficiaryDetails?.guardian_nationality_id,
          "nationality"
        ),
        guardian_actual_profession:
          beneficiaryDetails?.guardian_actual_profession || "",
        guardian_address: beneficiaryDetails?.guardian_address,
        guardian_phone: beneficiaryDetails?.guardian_phone,
        guardian_marital_status_id: getSelectValueByname(
          beneficiaryDetails?.guardian_marital_status_id,
          "marital_status"
        ),
        guardian_account_number: beneficiaryDetails?.guardian_account_number,
        guardian_bank_id: getSelectValueByname(
          beneficiaryDetails?.guardian_bank_id,
          "bank"
        ),
        guardian_account_owner: beneficiaryDetails?.guardian_account_owner,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beneficiaryDetails]);
  return (
    <>
      <Tabs
        tabBarStyle={{ display: "flex", overflowX: "auto" }}
        className={`takaful--content-profile-tab  ${
          props.className ? props.className : ""
        }`}
        defaultActiveKey="1"
        items={tabsData.map(({ label, number }, i) => {
          const id = String(i + 1);
          return {
            key: id,
            label: (
              <Row style={{ width: "100%" }}>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                  <div className="tab-label">
                    <span className="tab-label-text">{label}</span>
                    {label !== "العائل الرئيسي" && label !== "سكن الأسرة" && (
                      <div className="tab-number">
                        <span>{number}</span>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            ),
            children:
              label === "أفراد الأسرة" ? (
                <div className="takaful--collapse-profile-container">
                  <Collapse
                    {...props}
                    className={`takaful--collapse-profile`}
                    accordion
                    defaultActiveKey={["0"]}
                  >
                    {sortedData?.map((element, index) =>
                      element?.beneficiary_type !== "father" ? (
                        <Collapse.Panel
                          className="takaful--header-profile-Panel"
                          header={
                            <div className="takaful--header-profile-container">
                              <Row
                                justify={"space-between"}
                                className="takaful--content-profile-box1"
                                style={{ marginBottom: "0" }}
                              >
                                <Col
                                  xxl={5}
                                  xl={5}
                                  lg={5}
                                  md={5}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                >
                                  <p className="takaful--content-profile-col">
                                    الإسم
                                  </p>
                                </Col>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                >
                                  <span>{element?.name}</span>
                                </Col>

                                <Col
                                  xxl={1}
                                  xl={1}
                                  lg={1}
                                  md={1}
                                  sm={0}
                                  xs={0}
                                ></Col>

                                <Col
                                  xxl={5}
                                  xl={5}
                                  lg={5}
                                  md={5}
                                  sm={12}
                                  xs={12}
                                  style={{ marginRight: "-1rem" }}
                                  className="takaful--col-content"
                                >
                                  <p>رقم المستفيد</p>
                                </Col>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                  style={{ marginLeft: "-1.6rem" }}
                                  className="takaful--col-content"
                                >
                                  <span>{element?.beneficiary_number}</span>
                                </Col>
                              </Row>
                            </div>
                          }
                          key={index}
                        >
                          <Row
                            justify={"space-between"}
                            className={`takaful--content-profile-box1  ${
                              props.className ? props.className : ""
                            }`}
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>الهاتف</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <span>{element?.mobile}</span>
                            </Col>

                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>

                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                              <p>البريد الإلكتروني</p>
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                              <span>{element?.email}</span>
                            </Col>
                          </Row>
                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>الجنسية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <span>{element?.nationality_id}</span>
                            </Col>

                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>

                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                              <p>نوع المستفيد</p>
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                              <span>
                                {element?.beneficiary_type === "father"
                                  ? "الأب"
                                  : element?.beneficiary_type === "mother"
                                  ? "الأم"
                                  : element?.beneficiary_type === "son"
                                  ? "الإبن"
                                  : "الإبنة"}
                              </span>
                            </Col>
                          </Row>

                          <Row className="takaful--content-profile-box1">
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>تاريخ الميلاد </p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                              style={{ paddingRight: "0.5rem" }}
                            >
                              <span>
                                {element?.birthday
                                  ? dayjs(
                                      element.birthday,
                                      "YYYY-MM-DD"
                                    ).format("YYYY/MM/DD")
                                  : ""}
                              </span>
                            </Col>
                          </Row>

                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>الحالة الإجتماعية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {editMode === true ? (
                                <Selects
                                  allowClear={false}
                                  options={maritalStatus.data}
                                  className="takaful--select select-edit"
                                  value={
                                    editedPersons[element.id]
                                      ?.marital_status_id ||
                                    (element.marital_status_id
                                      ? getSelectValueByname(
                                          element.marital_status_id,
                                          "marital_status"
                                        )
                                      : [])
                                  }
                                  onChange={(selectedValues: any) =>
                                    handleInputChange(
                                      element.id,
                                      "marital_status_id",
                                      selectedValues.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.marital_status_id}</span>
                              )}
                            </Col>

                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>

                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                              <p>وضع الفرد</p>
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                              <span>
                                {t(
                                  `beneficiary_state.${element?.beneficiary_state}_${element?.gender}`
                                )}
                              </span>
                            </Col>
                          </Row>
                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>الحالة الصحية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Selects
                                  allowClear={false}
                                  options={healthStates.data}
                                  className="takaful--select select-edit"
                                  value={
                                    editedPersons[element.id]
                                      ?.health_state_id ||
                                    (element?.health_state_id
                                      ? getSelectValueByname(
                                          element?.health_state_id,
                                          "health_state"
                                        )
                                      : [])
                                  }
                                  onChange={(selectedValues: any) =>
                                    handleInputChange(
                                      element?.id,
                                      "health_state_id",
                                      selectedValues.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.health_state_id}</span>
                              )}
                            </Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>المستوى الدراسي</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Selects
                                  allowClear={false}
                                  options={academicLevels}
                                  className="takaful--select select-edit"
                                  value={
                                    editedPersons[element.id]
                                      ?.academic_level_id ||
                                    (element.academic_level_id
                                      ? getSelectValueByname(
                                          element.academic_level_id,
                                          "academic_level"
                                        )
                                      : [])
                                  }
                                  onChange={(selectedValues: any) =>
                                    handleInputChange(
                                      element.id,
                                      "academic_level_id",
                                      selectedValues.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.academic_level_id}</span>
                              )}
                            </Col>
                          </Row>

                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>الأمراض</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Selects
                                  options={diseaseType}
                                  mode="multiple"
                                  className="takaful--select-multiple"
                                  value={
                                    editedPersons[element.id]
                                      ?.disease_type_ids ||
                                    element.disease_type_ids.map(
                                      (method: any) => method.id
                                    )
                                  }
                                  onChange={(selectedValues: any) =>
                                    handleInputChange(
                                      element.id,
                                      "disease_type_ids",
                                      selectedValues.map(
                                        (item: any) => item.value
                                      )
                                    )
                                  }
                                />
                              ) : (
                                <div
                                  className=""
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    width: "100%",
                                  }}
                                >
                                  {element?.disease_type_ids?.map(
                                    (item: any) => (
                                      <TagComponent
                                        className="takaful--tag-style"
                                        state={element?.disbursement_status}
                                        text={item.name}
                                      />
                                    )
                                  )}
                                </div>
                              )}
                            </Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>السنة الدراسية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Selects
                                  allowClear={false}
                                  options={academicYears}
                                  className="takaful--select select-edit"
                                  value={
                                    editedPersons[element.id]
                                      ?.academic_year_id ||
                                    (element.academic_year_id
                                      ? getSelectValueByname(
                                          element.academic_year_id,
                                          "academic_year"
                                        )
                                      : [])
                                  }
                                  onChange={(selectedValues: any) =>
                                    handleInputChange(
                                      element.id,
                                      "academic_year_id",
                                      selectedValues.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.academic_year_id}</span>
                              )}
                            </Col>
                          </Row>

                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            ></Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            ></Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>مستوى التحصيل</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Selects
                                  allowClear={false}
                                  options={academicsPerformance}
                                  className="takaful--select select-edit"
                                  value={
                                    editedPersons[element.id]
                                      ?.academic_performance_id ||
                                    (element.academic_performance_id
                                      ? getSelectValueByname(
                                          element.academic_performance_id,
                                          "academic_performance"
                                        )
                                      : [])
                                  }
                                  onChange={(selectedValues: any) =>
                                    handleInputChange(
                                      element.id,
                                      "academic_performance_id",
                                      selectedValues.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.academic_performance_id}</span>
                              )}
                            </Col>
                          </Row>

                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>نوع الهوية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Selects
                                  allowClear={false}
                                  options={identificationTypes.data}
                                  className="takaful--select select-edit"
                                  value={
                                    editedPersons[element.id]
                                      ?.identification_type_id ||
                                    (element.identification_type_id
                                      ? getSelectValueByname(
                                          element.identification_type_id,
                                          "identification_type"
                                        )
                                      : [])
                                  }
                                  onChange={(selectedValues: any) =>
                                    handleInputChange(
                                      element.id,
                                      "identification_type_id",
                                      selectedValues.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.identification_type_id}</span>
                              )}
                            </Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>رقم الهوية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Inputs
                                  value={
                                    editedPersons[element.id]
                                      ?.identification_number ||
                                    element.identification_number
                                  }
                                  onChange={(e) =>
                                    handleInputChange(
                                      element.id,
                                      "identification_number",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.identification_number}</span>
                              )}
                            </Col>
                          </Row>

                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>مصدر الهوية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Inputs
                                  value={
                                    editedPersons[element.id]
                                      ?.identification_source ||
                                    element.identification_source ||
                                    ""
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  onChange={(e) =>
                                    handleInputChange(
                                      element.id,
                                      "identification_source",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.identification_source}</span>
                              )}
                            </Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>
                            {editMode === false ? (
                              <>
                                <Col
                                  xxl={5}
                                  xl={5}
                                  lg={5}
                                  md={5}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                >
                                  <p>تاريخ الهوية</p>
                                </Col>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                >
                                  <span>
                                    {element?.identification_date
                                      ? dayjs(
                                          element.identification_date,
                                          "YYYY-MM-DD"
                                        ).format("YYYY/MM/DD")
                                      : ""}
                                  </span>
                                </Col>
                              </>
                            ) : (
                              <>
                                <Col
                                  xxl={5}
                                  xl={5}
                                  lg={5}
                                  md={5}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                ></Col>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                ></Col>
                              </>
                            )}
                          </Row>
                          {/* eslint-disable-next-line eqeqeq */}
                          {editMode == true && (
                            <Row
                              justify={"space-between"}
                              className="takaful--content-profile-box1"
                            >
                              <Col
                                xxl={5}
                                xl={5}
                                lg={5}
                                md={5}
                                sm={24}
                                xs={24}
                                className="takaful--content-profile-col"
                              >
                                <p>تاريخ الهوية</p>
                              </Col>
                              <Col
                                xxl={11}
                                xl={11}
                                lg={11}
                                md={11}
                                sm={24}
                                xs={24}
                                className="takaful--content-profile-col"
                              >
                                <ConfigProvider locale={ar_EG} direction="rtl">
                                  <HijriFeature
                                    allowclear={false}
                                    onChange={(e) =>
                                      handleInputChange(
                                        element.id,
                                        "identification_date",
                                        dayjs(e).format("YYYY-MM-DD")
                                      )
                                    }
                                    value={
                                      editedPersons[element.id]
                                        ?.identification_date
                                        ? dayjs(
                                            editedPersons[element.id]
                                              ?.identification_date
                                          )
                                        : element.identification_date
                                        ? dayjs(element.identification_date)
                                        : null
                                    }
                                  />
                                </ConfigProvider>
                              </Col>
                              <Col
                                xxl={3}
                                xl={3}
                                lg={3}
                                md={3}
                                sm={0}
                                xs={0}
                              ></Col>
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={4}
                                sm={0}
                                xs={0}
                              ></Col>
                            </Row>
                          )}
                        </Collapse.Panel>
                      ) : (
                        <Collapse.Panel
                          className="takaful--header-profile-Panel"
                          header={
                            <div className="takaful--header-profile-container">
                              <Row
                                justify={"space-between"}
                                className="takaful--content-profile-box1"
                                style={{ marginBottom: "0" }}
                              >
                                <Col
                                  xxl={5}
                                  xl={5}
                                  lg={5}
                                  md={5}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                >
                                  <p className="takaful--content-profile-col">
                                    الإسم
                                  </p>
                                </Col>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                >
                                  <span>{element?.name}</span>
                                </Col>

                                <Col
                                  xxl={1}
                                  xl={1}
                                  lg={1}
                                  md={1}
                                  sm={0}
                                  xs={0}
                                ></Col>

                                <Col
                                  xxl={5}
                                  xl={5}
                                  lg={5}
                                  md={5}
                                  sm={12}
                                  xs={12}
                                  style={{ marginRight: "-1rem" }}
                                  className="takaful--col-content"
                                >
                                  <p>رقم المستفيد</p>
                                </Col>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                  style={{ marginLeft: "-1.6rem" }}
                                  className="takaful--col-content"
                                >
                                  <span>{element?.beneficiary_number}</span>
                                </Col>
                              </Row>
                            </div>
                          }
                          key={index}
                        >
                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>الجنسية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <span>{element?.nationality_id}</span>
                            </Col>

                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>

                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                              <p>نوع المستفيد</p>
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                              <span>
                                {element?.beneficiary_type === "father"
                                  ? "الأب"
                                  : element?.beneficiary_type === "mother"
                                  ? "الأم"
                                  : element?.beneficiary_type === "son"
                                  ? "الإبن"
                                  : "الإبنة"}
                              </span>
                            </Col>
                          </Row>

                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>تاريخ الميلاد </p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <span>
                                {element?.birthday
                                  ? dayjs(
                                      element.birthday,
                                      "YYYY-MM-DD"
                                    ).format("YYYY/MM/DD")
                                  : ""}
                              </span>
                            </Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>وضع الفرد</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <span>
                                {t(
                                  `beneficiary_state.${element?.beneficiary_state}_${element?.gender}`
                                )}
                              </span>
                            </Col>
                          </Row>

                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>نوع الهوية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Selects
                                  options={identificationTypes.data}
                                  className="takaful--select select-edit"
                                  value={
                                    editedPersons[element.id]
                                      ?.identification_type_id ||
                                    (element.identification_type_id
                                      ? getSelectValueByname(
                                          element.identification_type_id,
                                          "identification_type"
                                        )
                                      : [])
                                  }
                                  onChange={(selectedValues: any) =>
                                    handleInputChange(
                                      element.id,
                                      "identification_type_id",
                                      selectedValues.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.identification_type_id}</span>
                              )}
                            </Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>رقم الهوية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Inputs
                                  type="tel"
                                  value={
                                    editedPersons[element.id]
                                      ?.identification_number ||
                                    element.identification_number ||
                                    ""
                                  }
                                  onChange={(e) =>
                                    handleInputChange(
                                      element.id,
                                      "identification_number",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.identification_number}</span>
                              )}
                            </Col>
                          </Row>

                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p>مصدر الهوية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {/* eslint-disable-next-line eqeqeq */}
                              {editMode == true ? (
                                <Inputs
                                  value={
                                    editedPersons[element.id]
                                      ?.identification_source ||
                                    element.identification_source ||
                                    ""
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  onChange={(e) =>
                                    handleInputChange(
                                      element.id,
                                      "identification_source",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                <span>{element?.identification_source}</span>
                              )}
                            </Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>
                            {editMode === false ? (
                              <>
                                <Col
                                  xxl={5}
                                  xl={5}
                                  lg={5}
                                  md={5}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                >
                                  <p>تاريخ الهوية</p>
                                </Col>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                >
                                  <span>
                                    {element?.identification_date
                                      ? dayjs(
                                          element.identification_date,
                                          "YYYY-MM-DD"
                                        ).format("YYYY/MM/DD")
                                      : ""}
                                  </span>
                                </Col>
                              </>
                            ) : (
                              <>
                                <Col
                                  xxl={5}
                                  xl={5}
                                  lg={5}
                                  md={5}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                ></Col>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                  className="takaful--content-profile-col"
                                ></Col>
                              </>
                            )}
                          </Row>
                          {/* eslint-disable-next-line eqeqeq */}
                          {editMode == true && (
                            <Row
                              justify={"space-between"}
                              className="takaful--content-profile-box1"
                            >
                              <Col
                                xxl={5}
                                xl={5}
                                lg={5}
                                md={5}
                                sm={24}
                                xs={24}
                                className="takaful--content-profile-col"
                              >
                                <p>تاريخ الهوية</p>
                              </Col>
                              <Col
                                xxl={11}
                                xl={11}
                                lg={11}
                                md={11}
                                sm={24}
                                xs={24}
                                className="takaful--content-profile-col"
                              >
                                <ConfigProvider locale={ar_EG} direction="rtl">
                                  <HijriFeature
                                    allowclear={false}
                                    onChange={(e) =>
                                      handleInputChange(
                                        element.id,
                                        "identification_date",
                                        dayjs(e).format("YYYY-MM-DD")
                                      )
                                    }
                                    value={
                                      editedPersons[element.id]
                                        ?.identification_date
                                        ? dayjs(
                                            editedPersons[element.id]
                                              ?.identification_date
                                          )
                                        : element.identification_date
                                        ? dayjs(element.identification_date)
                                        : null
                                    }
                                  />
                                </ConfigProvider>
                              </Col>
                              <Col
                                xxl={3}
                                xl={3}
                                lg={3}
                                md={3}
                                sm={0}
                                xs={0}
                              ></Col>
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={4}
                                sm={0}
                                xs={0}
                              ></Col>
                            </Row>
                          )}
                          <Row>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>

                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                            ></Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                            ></Col>
                          </Row>
                        </Collapse.Panel>
                      )
                    )}
                  </Collapse>
                  {/* eslint-disable-next-line eqeqeq */}
                  {editMode == true && (
                    <Row
                      justify={"space-between"}
                      className="takaful--content-profile-box1"
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={10}
                        className="takaful--content-profile-col"
                      ></Col>
                      <div className="takaful--sponsor-secondary-button">
                        <SecondaryButton
                          title="تعديل"
                          onClick={() => {
                            setIsModalVisible(true);
                          }}
                        />
                      </div>
                    </Row>
                  )}
                </div>
              ) : label === "العائل الرئيسي" ? (
                <div className="takaful--collapse-profile-container">
                  <Collapse
                    {...props}
                    className={`takaful--collapse-profile`}
                    accordion
                    defaultActiveKey={["0"]}
                  >
                    <Collapse.Panel
                      className="takaful--header-profile-Panel"
                      header={
                        <div className="takaful--header-profile-container">
                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                            style={{ marginBottom: "0" }}
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p className="takaful--content-profile-col">
                                الإسم
                              </p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {editMode ? (
                                <Inputs
                                  value={guardianInfos.guardian_name}
                                  onChange={(e) =>
                                    handleGuardianInputChange(
                                      "guardian_name",
                                      e.target.value
                                    )
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                />
                              ) : (
                                <span>{CollapseArray?.guardian_name}</span>
                              )}
                            </Col>
                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>

                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              style={{ marginRight: "-1rem" }}
                              className="takaful--col-content"
                            >
                              <p>نوع الهوية</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {editMode ? (
                                <div onClick={(e) => e.stopPropagation()}>
                                  <Selects
                                    options={identificationTypes.data}
                                    value={
                                      guardianInfos.guardian_identification_type_id
                                    }
                                    onChange={(e: any) =>
                                      handleGuardianInputChange(
                                        "guardian_identification_type_id",
                                        e.value
                                      )
                                    }
                                  />
                                </div>
                              ) : (
                                <span>
                                  {
                                    CollapseArray?.guardian_identification_type_id
                                  }
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      }
                      key={1}
                    >
                      <Row
                        justify={"space-between"}
                        className={`takaful--content-profile-box1  ${
                          props.className ? props.className : ""
                        }`}
                      >
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p>رقم الهوية</p>
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          {editMode ? (
                            <Inputs
                              value={guardianInfos.guardian_identification}
                              onChange={(e) =>
                                handleGuardianInputChange(
                                  "guardian_identification",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>
                              {CollapseArray?.guardian_identification}
                            </span>
                          )}
                        </Col>
                        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                          <p>البريد الإلكتروني</p>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                          {editMode ? (
                            <Inputs
                              value={guardianInfos.guardian_email}
                              onChange={(e) =>
                                handleGuardianInputChange(
                                  "guardian_email",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>{CollapseArray?.guardian_email}</span>
                          )}
                        </Col>
                      </Row>
                      <Row
                        justify={"space-between"}
                        className="takaful--content-profile-box1"
                      >
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p>جنسية العائل</p>
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          {editMode ? (
                            <Selects
                              options={nationality.data}
                              value={guardianInfos.guardian_nationality_id}
                              onChange={(e: any) =>
                                handleGuardianInputChange(
                                  "guardian_nationality_id",
                                  e.value
                                )
                              }
                            />
                          ) : (
                            <span>
                              {CollapseArray?.guardian_nationality_id}
                            </span>
                          )}
                        </Col>

                        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                          <p>المهنة الحالية</p>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                          {editMode ? (
                            <Inputs
                              value={guardianInfos.guardian_actual_profession}
                              onChange={(e) =>
                                handleGuardianInputChange(
                                  "guardian_actual_profession",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>
                              {CollapseArray?.guardian_actual_profession}
                            </span>
                          )}
                        </Col>
                      </Row>

                      <Row
                        justify={"space-between"}
                        className="takaful--content-profile-box1"
                      >
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p>العنوان</p>
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          {editMode ? (
                            <Inputs
                              value={guardianInfos.guardian_address}
                              onChange={(e) =>
                                handleGuardianInputChange(
                                  "guardian_address",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>{CollapseArray?.guardian_address}</span>
                          )}
                        </Col>

                        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                          <p>الهاتف</p>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                          {editMode ? (
                            <Inputs
                              value={guardianInfos.guardian_phone}
                              onChange={(e) =>
                                handleGuardianInputChange(
                                  "guardian_phone",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>{CollapseArray?.guardian_phone}</span>
                          )}
                        </Col>
                      </Row>

                      <Row
                        justify={"space-between"}
                        className="takaful--content-profile-box1"
                      >
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p>الحالة الإجتماعية</p>
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          {editMode ? (
                            <Selects
                              options={maritalStatus.data}
                              value={guardianInfos.guardian_marital_status_id}
                              onChange={(e: any) =>
                                handleGuardianInputChange(
                                  "guardian_marital_status_id",
                                  e.value
                                )
                              }
                            />
                          ) : (
                            <span>
                              {CollapseArray?.guardian_marital_status_id}
                            </span>
                          )}
                        </Col>

                        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                          <p>رقم الحساب البنكي</p>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                          {editMode ? (
                            <Inputs
                              value={guardianInfos.guardian_account_number}
                              onChange={(e) =>
                                handleGuardianInputChange(
                                  "guardian_account_number",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>
                              {CollapseArray?.guardian_account_number}
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row
                        justify={"space-between"}
                        className="takaful--content-profile-box1"
                      >
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={11}
                          className="takaful--content-profile-col"
                        >
                          <p>البنك</p>
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          {editMode ? (
                            <Selects
                              options={banks}
                              value={guardianInfos.guardian_bank_id}
                              onChange={(e: any) =>
                                handleGuardianInputChange(
                                  "guardian_bank_id",
                                  e.value
                                )
                              }
                            />
                          ) : (
                            <span>{CollapseArray?.guardian_bank_id}</span>
                          )}
                        </Col>
                        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p>اسم صاحب الحساب البنكي</p>
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          {editMode ? (
                            <Inputs
                              value={guardianInfos.guardian_account_owner}
                              onChange={(e) =>
                                handleGuardianInputChange(
                                  "guardian_account_owner",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>{CollapseArray?.guardian_account_owner}</span>
                          )}
                        </Col>
                      </Row>
                    </Collapse.Panel>
                  </Collapse>
                  {/* eslint-disable-next-line eqeqeq */}
                  {editMode == true && (
                    <Row
                      justify={"space-between"}
                      className="takaful--content-profile-box1"
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={10}
                        className="takaful--content-profile-col"
                      ></Col>
                      <div className="takaful--sponsor-secondary-button">
                        <SecondaryButton
                          title="تعديل"
                          onClick={() => {
                            setIsModalVisibleGuardianInfos(true);
                          }}
                        />
                      </div>
                    </Row>
                  )}
                </div>
              ) : label === "سكن الأسرة" ? (
                <div className="takaful--collapse-profile-container">
                  <Collapse
                    {...props}
                    className={`takaful--collapse-profile`}
                    accordion
                    defaultActiveKey={["1"]}
                  >
                    <Collapse.Panel
                      className="takaful--header-profile-Panel"
                      header={
                        <div className="takaful--header-profile-container">
                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                            style={{ marginBottom: "0" }}
                          >
                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              <p className="takaful--content-profile-col">
                                نوع السكن
                              </p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              className="takaful--content-profile-col"
                            >
                              {editMode ? (
                                <div onClick={(e) => e.stopPropagation()}>
                                  <Selects
                                    options={housingTypes.data}
                                    value={housingInfos.housing_type_id}
                                    onChange={(e: any) =>
                                      handleHousingInputChange(
                                        "housing_type_id",
                                        e.value
                                      )
                                    }
                                    allowClear={false}
                                  />
                                </div>
                              ) : (
                                <span> {CollapseArray?.housing_type_id}</span>
                              )}
                            </Col>

                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>

                            <Col
                              xxl={5}
                              xl={5}
                              lg={5}
                              md={5}
                              sm={12}
                              xs={12}
                              style={{ marginRight: "-1rem" }}
                              className="takaful--col-content"
                            >
                              <p>ملكية السكن</p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                              style={{ marginLeft: "-1.6rem" }}
                              className="takaful--col-content"
                            >
                              {editMode ? (
                                <div
                                  className="takaful--col-housing-spaced"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <Selects
                                    options={housingOwnerships.data}
                                    allowClear={false}
                                    value={housingInfos.housing_ownership_id}
                                    onChange={(e: any) => {
                                      handleHousingInputChange(
                                        "housing_ownership_id",
                                        e.value
                                      );
                                      // eslint-disable-next-line eqeqeq
                                      setIsOwned(e.label == "ملك");
                                    }}
                                  />
                                </div>
                              ) : (
                                <span>
                                  {CollapseArray?.housing_ownership_id}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      }
                      key={1}
                    >
                      <Row
                        justify={"space-between"}
                        className={`takaful--content-profile-box1  ${
                          props.className ? props.className : ""
                        }`}
                      >
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p>حالة السكن</p>
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          {editMode ? (
                            <Selects
                              options={housingStates.data}
                              allowClear={false}
                              value={housingInfos.housing_state_id}
                              onChange={(e: any) =>
                                handleHousingInputChange(
                                  "housing_state_id",
                                  e.value
                                )
                              }
                            />
                          ) : (
                            <span>{CollapseArray?.housing_state_id}</span>
                          )}
                        </Col>

                        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                          <p>عدد الغرف</p>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                          {editMode ? (
                            <Inputs
                              value={housingInfos.rooms_number}
                              onChange={(e) =>
                                handleHousingInputChange(
                                  "rooms_number",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>{CollapseArray?.rooms_number}</span>
                          )}
                        </Col>
                      </Row>
                      {/* eslint-disable-next-line eqeqeq */}
                      {isOwned == false && (
                        <>
                          <Row
                            justify={"space-between"}
                            className="takaful--content-profile-box1"
                          >
                            <>
                              <Col
                                xxl={5}
                                xl={5}
                                lg={5}
                                md={5}
                                sm={12}
                                xs={12}
                                className="takaful--content-profile-col"
                              >
                                <p>مبلغ الإيجار</p>
                              </Col>
                              <Col
                                xxl={6}
                                xl={6}
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                className="takaful--content-profile-col"
                              >
                                {editMode ? (
                                  <Inputs
                                    value={housingInfos.rent_amount}
                                    onChange={(e) =>
                                      handleHousingInputChange(
                                        "rent_amount",
                                        e.target.value
                                      )
                                    }
                                  />
                                ) : (
                                  <span>{CollapseArray?.rent_amount}</span>
                                )}
                              </Col>
                            </>

                            <Col
                              xxl={1}
                              xl={1}
                              lg={1}
                              md={1}
                              sm={0}
                              xs={0}
                            ></Col>

                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                              <p>عقد الايجار الالكتروني</p>
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                              {editMode ? (
                                <>
                                  <UploadInput
                                    accept="*"
                                    text="عقد الايجار الالكتروني"
                                    icon={<UploadOutlined />}
                                    multiple={false}
                                    maxCount={1}
                                    onChange={handleFileChange}
                                  />
                                  <span>
                                    {Array.isArray(
                                      CollapseArray?.electronic_contract_attachment_ids
                                    ) &&
                                      CollapseArray
                                        .electronic_contract_attachment_ids
                                        .length > 0 &&
                                      CollapseArray.electronic_contract_attachment_ids.map(
                                        (certificate: any, index: any) => (
                                          <FileOutlined
                                            className="takaful--download-icon takaful--service-download-icon"
                                            onClick={(e) => {
                                              setPdfUrl(certificate);
                                            }}
                                          />
                                        )
                                      )}
                                  </span>
                                </>
                              ) : (
                                <span>
                                  {Array.isArray(
                                    CollapseArray?.electronic_contract_attachment_ids
                                  ) &&
                                    CollapseArray
                                      .electronic_contract_attachment_ids
                                      .length > 0 &&
                                    CollapseArray.electronic_contract_attachment_ids.map(
                                      (certificate: any, index: any) => (
                                        <FileOutlined
                                          className="takaful--download-icon takaful--service-download-icon"
                                          onClick={(e) => {
                                            setPdfUrl(certificate);
                                          }}
                                        />
                                      )
                                    )}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </>
                      )}
                      <Row
                        justify={"space-between"}
                        className="takaful--content-profile-box1"
                      >
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p>ملاحظات السكن</p>
                        </Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          {editMode ? (
                            <Inputs
                              value={housingInfos.housing_description}
                              onChange={(e) =>
                                handleHousingInputChange(
                                  "housing_description",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <span>{CollapseArray?.housing_description}</span>
                          )}
                        </Col>
                        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        ></Col>
                        <Col
                          xxl={6}
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        ></Col>
                      </Row>
                    </Collapse.Panel>
                  </Collapse>
                  {/* eslint-disable-next-line eqeqeq */}
                  {editMode == true && (
                    <Row
                      justify={"space-between"}
                      className="takaful--content-profile-box1"
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={10}
                        className="takaful--content-profile-col"
                      ></Col>
                      <div className="takaful--sponsor-secondary-button">
                        <SecondaryButton
                          title="تعديل"
                          onClick={() => {
                            setIsModalVisibleHousingInfos(true);
                          }}
                        />
                      </div>
                    </Row>
                  )}
                </div>
              ) : label === "ممتلكات الأسرة" ? (
                <div className="takaful--table-service-container">
                  <Table
                    className="takaful--table"
                    style={{ direction: "rtl", textWrap: "nowrap" }}
                    columns={columnsProperty}
                    scroll={{ x: "max-content" }}
                    dataSource={housingStatesData}
                    pagination={false}
                    locale={{
                      emptyText: (
                        <span className="takaful--empty-text-table">
                          لا توجد بيانات
                        </span>
                      ),
                    }}
                  />
                  {/* eslint-disable-next-line eqeqeq */}
                  {editMode == true && (
                    <Row
                      justify={"space-between"}
                      className="takaful--content-profile-box1"
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={10}
                        className="takaful--content-profile-col"
                      ></Col>
                      <div className="takaful--sponsor-secondary-button">
                        <SecondaryButton
                          title="تعديل"
                          onClick={() => {
                            setIsModalVisibleHousing(true);
                          }}
                        />
                      </div>
                    </Row>
                  )}
                </div>
              ) : label === "مصادر الدخل" ? (
                <div className="takaful--table-service-container">
                  <Table
                    className="takaful--table"
                    style={{ direction: "rtl", textWrap: "nowrap" }}
                    columns={columnsIncomeSource}
                    scroll={{ x: "max-content" }}
                    dataSource={materialStateData}
                    pagination={false}
                    locale={{
                      emptyText: (
                        <span className="takaful--empty-text-table">
                          لا توجد بيانات
                        </span>
                      ),
                    }}
                  />
                  {/* eslint-disable-next-line eqeqeq */}
                  {editMode == true && (
                    <Row
                      justify={"space-between"}
                      className="takaful--content-profile-box1"
                    >
                      <Col
                        xxl={5}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={10}
                        className="takaful--content-profile-col"
                      ></Col>
                      <div className="takaful--sponsor-secondary-button">
                        <SecondaryButton
                          title="تعديل"
                          onClick={() => {
                            setIsModalIncomeVisible(true);
                          }}
                        />
                      </div>
                    </Row>
                  )}
                </div>
              ) : (
                <EditLiablityTable liabilities={liabilityData} />
              ),
          };
        })}
      />
      <PdfPreview
        open={pdfUrl !== ""}
        onClose={() => setPdfUrl("")}
        url={pdfUrl}
        isBlob={false}
        className="takaful--pdf-preview-modal"
      />
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={cancelModification}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد إعتماد التعديل؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              onClick={cancelModification}
              title="لا"
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              onClick={confirmModification}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title=""
        open={isModalIncomeVisible}
        onClose={cancelIncomeModification}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد إعتماد التعديل؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              onClick={cancelIncomeModification}
              title="لا"
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              onClick={confirmIncomeModification}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title=""
        open={isModalVisibleHousing}
        onClose={cancelModificationHousing}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد إعتماد التعديل؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              onClick={cancelModificationHousing}
              title="لا"
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              onClick={confirmIncomeModificationHousing}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title=""
        open={isModalVisibleHousingInfos}
        onClose={cancelModificationHousingInfos}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد إعتماد التعديل؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              onClick={cancelModificationHousingInfos}
              title="لا"
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              onClick={confirmModificationHousingInfos}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title=""
        open={isModalVisibleGuardianInfos}
        onClose={cancelModificationGuardianInfos}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد إعتماد التعديل؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              onClick={cancelModificationGuardianInfos}
              title="لا"
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              onClick={confirmModificationGuardianInfos}
            />
          </Col>
        </Row>
      </ModalComponent>
    </>
  );
};

export default CollapseContent;
